import type { Article } from '@lib/types/directus/directusSchema';

const WORDS_PER_MINUTE = 275;

function countWords(htmlString: string) {
  const text = htmlString
    .replace(/<[^>]*>?/gm, '') // Remove HTML tags
    .replace(/\n/gm, ' ') // Remove line breaks
    .replace(/\s+/g, ' ') // Remove multiple spaces
    .trim(); // Remove leading/trailing spaces

  return text.split(' ').filter(Boolean).length;
}

export default function getReadingTimeForArticle(article: Article): number {
  const text = (article.body ?? '') + (article.conclusion ?? '') + (article.sources ?? '');

  const words = countWords(text);

  return Math.ceil(words / WORDS_PER_MINUTE);
}
